import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "pagination" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "carousel-container",
    style: _normalizeStyle({ height: _ctx.height + 'px' }),
    onMouseenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stopAutoplay && _ctx.stopAutoplay(...args))),
    onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startAutoplay && _ctx.startAutoplay(...args)))
  }, [
    _createElementVNode("div", {
      class: "scroll-container",
      ref: "scrollContainer",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["slide-item", { active: _ctx.currentIndex === index }])
        }, [
          _createElementVNode("img", {
            src: item.img,
            alt: "",
            class: "slide-blur-bg",
            draggable: "false",
            "aria-hidden": "true"
          }, null, 8, _hoisted_1),
          _createElementVNode("img", {
            src: item.img,
            alt: item.titleCn,
            class: "slide-bg",
            draggable: "false"
          }, null, 8, _hoisted_2)
        ], 2))
      }), 128))
    ], 544),
    _createElementVNode("button", {
      class: "nav-btn prev",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevSlide && _ctx.prevSlide(...args))),
      "aria-label": "Previous Slide"
    }, [...(_cache[5] || (_cache[5] = [
      _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M15 18L9 12L15 6",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]))]),
    _createElementVNode("button", {
      class: "nav-btn next",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args))),
      "aria-label": "Next Slide"
    }, [...(_cache[6] || (_cache[6] = [
      _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M9 18L15 12L9 6",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]))]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (_, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: 'dot-' + index,
          class: _normalizeClass(["dot", { active: _ctx.currentIndex === index }]),
          onClick: ($event: any) => (_ctx.goToSlide(index))
        }, null, 10, _hoisted_4))
      }), 128))
    ])
  ], 36))
}